var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('v-tooltip',{attrs:{"left":!_vm.right,"right":_vm.right,"max-width":"250"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"background-color":"white","border-radius":"9999px"},attrs:{"color":"blue"}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}],null,false,2984223815)},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }